export default "__VITE_ASSET__vwurs1Zl__"